// Copyright (c) 2025 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

function handleOnClick() {

    this.closeDealerRecommendationModal();

}

const DealerRecommendationModalHeader = props =>
    <header className='machine-update-modal-header'>
        <FormattedMessage
            id={`${props.dealerRecommendationModalAction.toUpperCase()}_DEALER_RECOMMENDATIONS`}
        />
        <span
            className='close-modal-icon'
            onClick={props::handleOnClick}
        />
    </header>;

DealerRecommendationModalHeader.displayName = 'DealerRecommendationModalHeader';
DealerRecommendationModalHeader.propTypes = {
    closeDealerRecommendationModal: PropTypes.func.isRequired,
    dealerRecommendationModalAction: PropTypes.string.isRequired

};

export default DealerRecommendationModalHeader;



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/components/dealer-recommendation-modal-header.js